import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from '../../store/modules/search/actionTypes';

import { setQueryFilters } from './utils';

export default function* listenSetQueryFilters() {
  yield takeEvery(actionTypes.SET_QUERY_FILTERS, setQueryFilters);
}
